import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { AjaxService } from '.././services/ajax.service';
import { EmitterService } from './emitter.service';
import { Router } from '@angular/router';
import { TranslateService } from "@ngx-translate/core";
import { BannerService } from './banner.service';
import localeEn from '@angular/common/locales/en';
import localeEi from '@angular/common/locales/en-IN';
import localeFi from '@angular/common/locales/fi';
import localeSv from '@angular/common/locales/sv';
import localeNb from '@angular/common/locales/nb';
import localeDe from '@angular/common/locales/de';
import localeJa from '@angular/common/locales/ja';
import localeCa from '@angular/common/locales/en-CA';
import localeNz from '@angular/common/locales/en-NZ';
import localeFr from '@angular/common/locales/fr-CD';
import localeKo from '@angular/common/locales/ko';
import localeEe from '@angular/common/locales/ee';
import localeHu from '@angular/common/locales/hu';
import { Utility } from '../shared/utility/utility';
import { language, APIACCOUNTVERIFICATION, APPACCOUNTVERIFICATION } from '../shared/utility/config';
import { registerLocaleData } from '@angular/common';
import { FormGroup} from '@angular/forms';
import { CountryDataService } from './country.service';
import { environment } from '../../environments/environment';
import { takeUntil } from 'rxjs/operators';
import { GameWindowService } from '../services/gameWindow.services';
import * as $ from 'jquery';
window['$'] = window['jQuery'] = $;
import * as _ from 'underscore';
@Injectable()
export class UserDetailsService implements OnDestroy {
  checkUserProfileResponse = null;
  checkUserProfileCallStack=[];
  userProfileDetails;
  userCashBalance = 0;
  userBonusBalance = 0;
  userTotalBalance = 0;
  userBalanceDetails;
  userCurrencyDetails;
  userKycDetails;
  userCurrency: any;
  userCurrencySymbol: any;
  defaultCurrencySymbol: any = "$";
  defaultCurrencyCashier='€';
  defaultCurrency: any = "USD";
  zimplerDefaultCurrencySybmol: any = "€";
  bannerfields;
  isUserLoggedIn;
  accountKyc = {
    status: "",
    documents: {
      identityStatus: "",
      addressStatus: "",
      sourceOfIncomeStatus: "",
      sourceOfIncomeDetails: "",
      sourceOfIncomeOtherValue: ""
    }
  };
  completeUser;
  userOtpCheck = false;
  userCountry;
  trustlyObject;
  sessionExpired = false;
  langCode;
  destroy$: Subject<boolean> = new Subject<boolean>();
  isSameGameLaunched = false;
  isGameLaunchChecksCanStart = true;
  isZimplerProfile;
  isRealUser = false;
  semiPnpUserInfo;
  userPreferenceData;

  userCurrencyInfo;
  private userProfileUpdated = new Subject<string>();
  userProfileUpdated$ = this.userProfileUpdated.asObservable();

  private userBalanceUpdated = new Subject<string>();
  userBalanceUpdated$ = this.userBalanceUpdated.asObservable();

  private userCashBalanceUpdated = new Subject<string>();
  userCashBalanceUpdated$ = this.userCashBalanceUpdated.asObservable();

  private userBonusBalanceUpdated = new Subject<string>();
  userBonusBalanceUpdated$ = this.userBonusBalanceUpdated.asObservable();

  private userTotalBalanceUpdated = new Subject<string>();
  userTotalBalanceUpdated$ = this.userTotalBalanceUpdated.asObservable();

  private userKycUpdated = new Subject<string>();
  userKycUpdated$ = this.userKycUpdated.asObservable();

  private userCurrencyUpdated = new Subject<string>();
  userCurrencyUpdated$ = this.userCurrencyUpdated.asObservable();

  private userCountryUpdated = new Subject<string>();
  userCountryUpdated$ = this.userCountryUpdated.asObservable();

  constructor(
    private ajaxService: AjaxService,
    private emitterService: EmitterService,
    private router: Router,
    private bannerService: BannerService,
    private translateService: TranslateService,
    private utils: Utility,
    private countryDataService: CountryDataService,
    private gmService: GameWindowService
  ) { 

    this.langCode = localStorage.getItem('langCode')
    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode =>{
      this.langCode = langCode;
    });

    this.emitterService.logoutComplete$.pipe(takeUntil(this.destroy$)).subscribe(data=>{
        if(data.includes('true')) {
          this.checkUserProfileResponse = null;
          this.checkUserProfileCallStack=[];
        }
      });
  
    this.emitterService.checkUserProfileFlag$.pipe(takeUntil(this.destroy$)).subscribe(data=>{
        this.checkUserProfileResponse=null;
        this.checkUserProfileCallStack = [];
    });

    this.emitterService.updateLoginStatus$.pipe(takeUntil(this.destroy$)).subscribe(loginStatus => {
      this.isUserLoggedIn = loginStatus;
    });

    this.emitterService.loginComplete$.pipe(takeUntil(this.destroy$)).subscribe(loginStatus => {
     if(!loginStatus){
      this.sessionExpired = false;
      this.isRealUser = false;
     }
    });

    this.emitterService.isGamewindowLanuched$.pipe(takeUntil(this.destroy$)).subscribe(status => {
      this.isGameLaunchChecksCanStart = true;
    });

    this.emitterService.isGameWindowMinimized$.pipe(takeUntil(this.destroy$)).subscribe(status => {
      this.isGameLaunchChecksCanStart = true;
    });

    this.emitterService.isZimplerForm$.pipe(takeUntil(this.destroy$)).subscribe(data=>{
      this.isZimplerProfile = data;
    });

  }

  resetUserDetails() {
    this.userCurrency = undefined;
    this.userCurrencySymbol = undefined;
    this.userProfileDetails = undefined;
    this.setUserBalanceDetails = undefined;
    this.userCashBalance = 0;
    this.userBonusBalance = 0;
  }

  setUserCurrencyCode(code): any {
    this.userCurrency = code;
  }
  setUserCurrencyInfo(currencyDetails): any {
    this.userCurrencyInfo = currencyDetails;
  }
  getUserCurrencyInfo(): any {
    return this.userCurrencyInfo
  }
  setUserCurrencySymbol(symbol): any {
    this.userCurrencySymbol = symbol;
  }
  getUserCurrencyCode(): any {
    return this.userCurrency;
  }
  setUserProfileDetails(userProfile): any {
    this.userProfileDetails = userProfile;
    this.isRealUser = userProfile && userProfile["userStatus"] === "real" ? true : false;
  }
  // setuserProfileDetails(profileDetails): any {
  //   this.userProfileDetails = profileDetails;
  // }

  getUserProfileDetails(): any {
    return this.userProfileDetails;
  }

  getUserName(){
    return this.userProfileDetails!==undefined?this.userProfileDetails.firstName: "";
  }

  setUserBonusBalance(userBonusBalance) {
    this.userBonusBalance = userBonusBalance;
    this.userBonusBalanceUpdated.next(userBonusBalance);
  }

  getUserBonusBalance() {
    return this.userBonusBalance;
  }

  setUserOTPCheck(otpcheck) {
    this.userOtpCheck = otpcheck;
  }

  getUserOTPCheck() {
    return this.userOtpCheck;
  }
  setSemiPnpUserData(data){
    this.semiPnpUserInfo = data;
  }
  getSemiPnpUserData(){
    return this.semiPnpUserInfo;
  }

  setUserCashBalance(userCashBalance) {
    this.userCashBalance = userCashBalance;
    this.userCashBalanceUpdated.next("UserCashBalanceUpdated");
  }

  getUserCashBalance() {
    return this.userCashBalance;
  }

  setUserTotalBalance(userTotalBalance) {
    this.userTotalBalance = userTotalBalance;
    this.userTotalBalanceUpdated.next(userTotalBalance);
  }

  getUserTotalBalance() {
    return this.userTotalBalance;
  }

  setUserBalanceDetails(userBalanceDetails) {
    this.userBalanceDetails = userBalanceDetails;
    this.userBalanceUpdated.next("UserBalanceUpdated");
  }

  getUserBalanceDetails() {
    return this.userBalanceDetails;
  }

  setUserCurrencyDetails(userCurrencyDetails) {
    this.userCurrencyDetails = userCurrencyDetails;
    this.userCurrencyUpdated.next("UserCurrencyUpdated");
  }

  getUserCurrencyDetails() {
    return this.userCurrencyDetails;
  }

  setUserKycDetails(userKycDetails) {
    this.userKycDetails = userKycDetails;
    this.userKycUpdated.next("UserKycUpdated");
  }

  getUserKycDetails() {
    return this.userKycDetails;
  }
  checkUserProfile(isForce=false): Promise<String> {
    // return this.ajaxService.checkUserProfile();
    if (this.checkUserProfileResponse && !isForce){
      return this.checkUserProfileResponse;
    }else{
      return new Promise((resolve,reject)=>{
        if(this.checkUserProfileCallStack.length > 0){
          this.checkUserProfileCallStack.push(resolve);
        }
        else{
          this.checkUserProfileCallStack.push(resolve);
          Promise.resolve(this.ajaxService.checkUserProfile()).then(checkUserProfileData => {
            if(checkUserProfileData){
              this.checkUserProfileResponse = checkUserProfileData;
              for(let call in this.checkUserProfileCallStack){
                this.checkUserProfileCallStack[call](this.checkUserProfileResponse);
              }
              this.checkUserProfileCallStack=[];
            }
          });
        }
      });
    }
  }
  getCurrencyCode(): any {
    return this.userCurrency ? this.userCurrency : this.defaultCurrency;
  }
  getUserCurrencySymbol(): any {
    return this.userCurrencySymbol ? this.userCurrencySymbol : this.defaultCurrencySymbol;
  }
  getUserCurrencyForCahier(): any {
    return this.userCurrencySymbol ? this.userCurrency : this.defaultCurrencyCashier;
  }

  getZimplerDefaultCurrencySybmol(){
    return this.zimplerDefaultCurrencySybmol
  }
  getDefaultCurrencyCode(): any {
    return this.defaultCurrency;
  }
  getDefaultCurrencySymbol(): any {
    return this.defaultCurrencySymbol;
  }
  // otpCheck(message,email){
  //   this.loginSubscription = this.emitterService.loginComplete$.subscribe(loginStatus => {
  //     // getUserDetails(loginStatus)
  //     if (loginStatus["mobileVerificationStatus"] != null && loginStatus["mobileVerificationStatus"] == "success" ) {
  //       this.codereVerify(email)
  //         this.router.navigate(['/otp']  );
  //         }
  //         else{
  //       Promise.resolve(this.ajaxService.checkUserProfile())
  //         .then(completeUserStatus => {
  //           this.completeUser = completeUserStatus;
  //           if (this.completeUser.userProfileCompleted) {
  //             this.router.navigate(['/']);
  //           } else {
  //             this.router.navigate(['/completeprofile']);
  //           }
  //         })
  //       }
  //   });
  // }
  // codereVerify(email) {

  //   let logincredentials = {
  //     'email': email,
  //     'channel': "sms"
  //   }
  //   Promise.resolve(this.ajaxService.resendEmailVerification(logincredentials))
  //     .then(regData => {
  //     },
  //       SystemError => {
  //         this.emitterService.broadcastserverError('', "/register")
  //       })
  // }
  bannerFieldsComplete(userDataStatus: any) {
    this.bannerfields = userDataStatus;
  }
  getbannerFieldsComplete() {
    return this.bannerfields;
  }
  getUserLifeTimeTransactionSummary(): any {
    let isKycBlocked = true;
    return Promise.resolve(this.ajaxService.getUserLifeTimeTransactionSummary()).then(lifeTimeSummary => {
        if (lifeTimeSummary["requestedWithdrawalAmountinInhouseCurrency"] >= lifeTimeSummary["kycEnableDepositOrCashoutsLimit"]  || lifeTimeSummary["successfulDepositAmountInhouseCurrency"] >= lifeTimeSummary["kycEnableDepositOrCashoutsLimit"] ) { 
          isKycBlocked = false;
        }
        return isKycBlocked;
      });
  }
  getAccountVerificationStatus(): any {
    return Promise.resolve(this.ajaxService.getAccountVerificationStatus())
      .then(verificationData => {
        if (verificationData && verificationData["documents"]) {

          let sourceOfIncomeOtherValue = verificationData["documents"].sourceOfIncomeDetails ? verificationData["documents"].sourceOfIncomeDetails.filter(({ docType }) => docType === "other") : "";
          let otherValue = sourceOfIncomeOtherValue.length > 0 ? sourceOfIncomeOtherValue[0]["docInfo"] : "";
          this.accountKyc.documents.sourceOfIncomeDetails = verificationData["documents"].sourceOfIncomeDetails ? verificationData["documents"].sourceOfIncomeDetails.map(({ docType }) => docType) : "";
          this.accountKyc.documents.sourceOfIncomeOtherValue = otherValue;

          this.accountKyc.documents.identityStatus = this.getDocumentStatus(verificationData["documents"].identityStatus);         
          this.accountKyc.documents.addressStatus = this.getDocumentStatus(verificationData["documents"].addressStatus);
          this.accountKyc.documents.sourceOfIncomeStatus = this.getDocumentStatus(verificationData["documents"].sourceOfIncomeStatus);
 
          if(this.isAccountKycVerified()) this.accountKyc.status = APPACCOUNTVERIFICATION.VERIFIED;
          else if (this.isAccountKycInitiated()) this.accountKyc.status = APPACCOUNTVERIFICATION.INITIATED;
          else if (this.isAccountKycNew()) this.accountKyc.status = APPACCOUNTVERIFICATION.NEW;
          else if (this.isAccountKycPendingwithAddressProof()) this.accountKyc.status = APPACCOUNTVERIFICATION.ADDRESSSTATUS_PENDING;
          else if (this.isAccountKycPendingwithIdentityProof()) this.accountKyc.status = APPACCOUNTVERIFICATION.IDENTITYSTATUS_PENDING;
          else if (this.isAccountKycPendingwithSourceofIncome()) this.accountKyc.status = APPACCOUNTVERIFICATION.SOURCEOFINCOMESTATUS_PENDING;
          else this.accountKyc.status = APPACCOUNTVERIFICATION.NOTVERIFIED
          
          return this.accountKyc;
        }
      });
  }

  private isAccountKycNew() {
    return (this.accountKyc.documents.identityStatus === APPACCOUNTVERIFICATION.NEW ||
            this.accountKyc.documents.identityStatus === APPACCOUNTVERIFICATION.NOTVERIFIED) &&
            (this.accountKyc.documents.addressStatus === APPACCOUNTVERIFICATION.NEW ||
            this.accountKyc.documents.addressStatus === APPACCOUNTVERIFICATION.NOTVERIFIED);
  }
  private isAccountKycVerified() {
    return this.accountKyc.documents.identityStatus === APPACCOUNTVERIFICATION.VERIFIED &&
           this.accountKyc.documents.addressStatus === APPACCOUNTVERIFICATION.VERIFIED &&
           this.accountKyc.documents.sourceOfIncomeStatus !== APPACCOUNTVERIFICATION.NEW &&
           this.accountKyc.documents.sourceOfIncomeStatus !== APPACCOUNTVERIFICATION.NOTVERIFIED;
  }
  private isAccountKycInitiated() {
    return (this.accountKyc.documents.identityStatus === APPACCOUNTVERIFICATION.INITIATED ||
            this.accountKyc.documents.identityStatus === APPACCOUNTVERIFICATION.VERIFIED) &&
            (this.accountKyc.documents.addressStatus === APPACCOUNTVERIFICATION.INITIATED ||
            this.accountKyc.documents.addressStatus === APPACCOUNTVERIFICATION.VERIFIED) &&
            (this.accountKyc.documents.sourceOfIncomeStatus === APPACCOUNTVERIFICATION.INITIATED ||
            this.accountKyc.documents.sourceOfIncomeStatus === APPACCOUNTVERIFICATION.VERIFIED);
  }
  private isAccountKycPendingwithAddressProof() {
    return this.accountKyc.documents.addressStatus === APPACCOUNTVERIFICATION.NEW ||
           this.accountKyc.documents.addressStatus === APPACCOUNTVERIFICATION.NOTVERIFIED;
  }
  private isAccountKycPendingwithIdentityProof() {
    return this.accountKyc.documents.identityStatus === APPACCOUNTVERIFICATION.NEW ||
           this.accountKyc.documents.identityStatus === APPACCOUNTVERIFICATION.NOTVERIFIED;
  }
  private isAccountKycPendingwithSourceofIncome() {
    return (this.accountKyc.documents.identityStatus === APPACCOUNTVERIFICATION.INITIATED ||
            this.accountKyc.documents.identityStatus === APPACCOUNTVERIFICATION.VERIFIED) &&
            (this.accountKyc.documents.addressStatus === APPACCOUNTVERIFICATION.INITIATED ||
            this.accountKyc.documents.addressStatus === APPACCOUNTVERIFICATION.VERIFIED) &&
            (this.accountKyc.documents.sourceOfIncomeStatus === APPACCOUNTVERIFICATION.NEW ||
            this.accountKyc.documents.sourceOfIncomeStatus === APPACCOUNTVERIFICATION.NOTVERIFIED);
  }
  private getDocumentStatus(documentType) {
    return documentType === APIACCOUNTVERIFICATION.VERIFIED ? APPACCOUNTVERIFICATION.VERIFIED :
           documentType === APIACCOUNTVERIFICATION.INITIATED ? APPACCOUNTVERIFICATION.INITIATED :
           documentType === APIACCOUNTVERIFICATION.FAILED ? APPACCOUNTVERIFICATION.NOTVERIFIED : APPACCOUNTVERIFICATION.NEW;
  }
  // getAccountVerificationStatus(isConfirmId){
  //   this.isConfirmId = isConfirmId;
  //   // return isConfirmId;
  // }
  // getConfirmIdStatus(){
  //   return this.isConfirmId;

  // }

  checkConfirmationofIdentity(data) {
    let confirmIdentityStatus = {
      isKycBlocked: false ,
      isNew: false,
      isVerified: false,
      isInitiated: false,
      showInitiatedOrVerifiedComponent: false
    }
    confirmIdentityStatus.isKycBlocked = data[1];
    if (data[0].status === APPACCOUNTVERIFICATION.VERIFIED) {
      confirmIdentityStatus.isVerified = true;
      confirmIdentityStatus.showInitiatedOrVerifiedComponent = true;
    }
    else if (data[0].status === APPACCOUNTVERIFICATION.INITIATED ||
             data[0].status === APPACCOUNTVERIFICATION.SOURCEOFINCOMESTATUS_PENDING) {
      confirmIdentityStatus.isInitiated = true;
      confirmIdentityStatus.showInitiatedOrVerifiedComponent = true;
    }
    else if (data[0].status === APPACCOUNTVERIFICATION.NEW ||
            data[0].status === APPACCOUNTVERIFICATION.NOTVERIFIED ||
            data[0].status === APPACCOUNTVERIFICATION.ADDRESSSTATUS_PENDING ||
            data[0].status === APPACCOUNTVERIFICATION.IDENTITYSTATUS_PENDING
            ) {
      confirmIdentityStatus.isNew = true;
      confirmIdentityStatus.showInitiatedOrVerifiedComponent = false;
    }
    return confirmIdentityStatus;
  }

  doLogout(isForce=false) {
    this.utils.cashierConfigInfo=null;
    this.bannerService.cashierBanners = null;
    localStorage.removeItem('sessionTimerInfo');
    sessionStorage.removeItem("user");
    this.userProfileDetails = null;
    this.utils.cashierConfigInfo =undefined;
    this.emitterService.broadCastPromotionsDataClear(true)
    if(this.sessionExpired && !isForce) {
      return true;
    } else {
      Promise.resolve(this.ajaxService.doLogout()).then(
          loginData => {
            this.sessionExpired = true;
            sessionStorage.removeItem("amount");
            sessionStorage.removeItem("bonusCode");
            this.emitterService.broadcastStatusCall("updated");
            this.emitterService.broadCastUserCountry(this.countryDataService.IPCountry);
            this.utils.closeModal("sessionExpiredModal");
            this.removeUserData(); 
            this.utils.closeMultiModal("sessionExpiredModal");
            this.isUserLoggedIn = false;
            this.emitterService.broadcastlogoutComplete("true");
            this.emitterService.broadcastGetLangBasedResponse(true);
            this.emitterService.broadcastLoginStatus(false);
            this.emitterService.broadcastLoadHomeBanner("userLoggedOff");
            this.bannerFieldsComplete("");
            this.router.navigate(['/' + this.langCode]);
            this.bannerService.clearBanners();
            this.gmService.forceLatestPlayedGames = true;
            this.gmService.setFavouriteGames({});
            localStorage.removeItem('registerUserData')
            localStorage.removeItem('hashedPassword')
            localStorage.removeItem('newUserZimpler');
            this.emitterService.broadCastLogoutAndLoginStatus('logout');
            
          },
          SystemError => {
            this.emitterService.broadcastserverError(" ", "/");
          }
        )
    }
  }

  checkmobilereg(validateValues): any {
    // let mobileNumberUniqueCheck=0;

    // let validateValues = {
    //   mobileNumber: this.steponeDetails.phone,
    //   mobileIsdCode:this.steponeDetails.areaCode
    // }
    return Promise.resolve(this.ajaxService.validateCheckMobile(validateValues))
      .then(uniqueData => {
        let message;
        // if(--mobileNumberUniqueCheck == 0 ){
        if (uniqueData && uniqueData["status"] === "SUCCESS") {
          message = null;
          // this.PhoneForm.controls['phone'].setErrors(null);
        } else {
          message = "already exists";
          // this.PhoneForm.controls['phone'].setErrors(message);
        }
        // }

        return message;
      });
  }
  getLanguage() {
    registerLocaleData(localeEn, 'en');
    registerLocaleData(localeFi, 'fi');
    registerLocaleData(localeNb, 'no');
    registerLocaleData(localeSv, 'sv');
    registerLocaleData(localeDe, 'de');
    registerLocaleData(localeJa, 'ja');
    registerLocaleData(localeCa, 'cd');
    registerLocaleData(localeNz, 'nz');
    registerLocaleData(localeFr, 'fr');
    registerLocaleData(localeKo, 'ko');
    registerLocaleData(localeEe, 'et');
    registerLocaleData(localeEi, 'ei');
    registerLocaleData(localeHu, 'hu');
    let lang= localStorage.getItem("langCode");
    if(lang){
      switch (lang) {
        case ('en'):
          return 'en';
        case ('fi'):
          return 'fi';
        case ('no'):
          return 'no';
        case ('sv'):
          return 'sv';
        case ('de'):
          return 'de';
        case ('ja'):
          return 'ja';
        case ('cd'):
          return 'cd';
        case ('nz'):
          return 'nz';
        case ('fr'):
          return 'fr';
        case ('ko'):
          return 'ko';
        case ('in'):
          return 'ei';
        case ('et'):
          return 'et';
        case ('hu'):
          return 'hu';
         
      }
    }
  }
  getUserCountry(){
    return this.userCountry;
  }
  setUserCountry(country: string){
    this.userCountry = country;
    this.userCountryUpdated.next(country);
  }
  getTrustlyObject(){
    return this.trustlyObject;
  }
  setTrustlyObject(object: any){
    this.trustlyObject = object;
  }

  /* Function to set languagecode and userlanguagecode for a logged in user */
  setUserLangCode(userLanguage: string, currentLanguage: string){
  let websiteLanguages = this.utils.mappedLanguageCodes();
  if (userLanguage && language[currentLanguage] !== userLanguage){
    let newLang  = "";
    /* Loop through the map and get the desired key */
    Object.entries(language).forEach(
      ([key, value]) => {
        if (value === userLanguage && _.contains(websiteLanguages, key)) {
          newLang = key;
        }
      }
    );
    if (newLang == ""){
      newLang = 'en';
    }
    /*Blocked the below line as issues were coming for codes: en_EN, en_CD,en_NZ */
    localStorage.setItem('langCode', newLang);
    // localStorage.setItem('userLangCode', newLang);
    this.emitterService.broadcastLangCode(newLang);
    this.emitterService.broadcastGetLangBasedResponse(true)
    this.translateService.use(newLang);
  }
}
  /* Function to remove the space on the left or right of string by trimming */
  public cleanForm(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((key) => {
      if (typeof(formGroup.get(key).value) === "string")
        formGroup.get(key).setValue(formGroup.get(key).value.trim())
      }
    );
    return formGroup;
  }
  
    /* Function to remove user data */
    removeUserData() {
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("session");
      localStorage.removeItem("loginstatus");
    }

  isUserExemptedFromRegStepThree(userCountry = this.countryDataService.ipCountry) {

    // STEP 3 is not present in Njord
    return true;

    // if (environment.totalStepThreeRegistrationExemption[userCountry]) { 
    //   return true;
    // }
    // if (environment.stepThreeRegistrationExemption &&
    //   environment.stepThreeRegistrationReqCountriesWhenExempted.indexOf(this.countryDataService.ipCountry) === -1 &&
    //   environment.stepThreeRegistrationReqCountriesWhenExempted.indexOf(userCountry) === -1
    //  ) {
    //   return true;
    // }
    // return false;
  }
  
  checkZimplerUpdateOpen(){
    return !this.checkIsEmailUpdated()
  }
  
  checkZimplerDepositOpen(){
    if(this.isUserLoggedIn) {
      if(this.isZimplerProfile) this.emitterService.broadCastIsZimplerForm(false)
      return this.checkIsPNPUser()
    } else {
      return (this.emitterService.getIsCountryAllowed() === 1)
    }
  }
  
  checkIsPNPUser(){
    let country = this.userProfileDetails && this.userProfileDetails.country ? this.userProfileDetails.country : (this.countryDataService && this.countryDataService.ipCountry ? this.countryDataService.ipCountry : "");
    return ((this.emitterService.getIsCountryAllowed() === 1 || this.emitterService.getIsCountryAllowed() === 2) && (environment.zimplerPnp.indexOf(country) >= 0 || environment.zimplerCountries.indexOf(country) >= 0 || environment.semiPnpZimplerCountries.indexOf(country) >= 0))
  }
  
  checkIsEmailUpdated(): boolean{
    const userProfileDetails = this.userProfileDetails;
    if(userProfileDetails && userProfileDetails['email']){
      return this.doEmailMatch(userProfileDetails['email'])
    }else{
      this.ajaxService.getProfileBalanceCurrency(true).pipe(takeUntil(this.destroy$)).subscribe(data=>{
        if(data && data['profile']){
          this.setUserProfileDetails(data['profile'])
          return this.checkIsEmailUpdated()
        }
      });
    }
  }
  
  doEmailMatch(emailId){
    let numberRegex=new RegExp('^[0-9]+$')
    if(emailId){
      let emailSegments = emailId.split('@');
      if(numberRegex.test(emailSegments[0]) && emailSegments[1].startsWith(environment.website_name + '.com')){
        return false
      }
      return true
    }
  }

  gamePlayLaunchChecks(gameId, gameLaunchUrlPath) {
    if(this.isGameLaunchChecksCanStart) {
      this.isGameLaunchChecksCanStart = false;

      let gameInfo = this.utils.getActiveGameInfo();
      let allGamesData = this.gmService.getMultiLingualGameObj();
      let activeGameId = (gameInfo && gameInfo.gameId && gameInfo.gameId !== undefined) ? gameInfo.gameId : null;
      let activeGameLaunchUrlPath = (gameInfo && gameInfo.gameLaunchUrlPath && gameInfo.gameLaunchUrlPath !== undefined) ? gameInfo.gameLaunchUrlPath : activeGameId;

      //if launched with CTA if dont have game code set gameId to gameLaunchUrlPath by the gameLaunchUrlPath from method params

      // if gameId not available set gameId by gameLaunchUrlPath
      if(!gameId){
        gameId = allGamesData[gameLaunchUrlPath] ? allGamesData[gameLaunchUrlPath].gameCode : null;
      } 

      // if gameLaunchUrlPath not available set same value of gameId to gameLaunchUrlPath to launch the game
      if(gameId && !gameLaunchUrlPath){
        gameLaunchUrlPath = gameId;
      }
  
      // store the launched game data here
      if(gameLaunchUrlPath && (activeGameLaunchUrlPath !== gameLaunchUrlPath)) {
        $("#gameIframeWrapper").removeClass('transparentBg');
        $("#gameIframeWrapper").html('');
        let launchedGameInfo = {};
        launchedGameInfo['gameId'] = gameId;
        launchedGameInfo['gameLaunchUrlPath'] = gameLaunchUrlPath;
        this.utils.setActiveGameInfo(launchedGameInfo);
        this.isSameGameLaunched = false;
      } else if(gameLaunchUrlPath && (activeGameLaunchUrlPath === gameLaunchUrlPath)) {
        this.isSameGameLaunched = true;
      }
  
      // check if user logged or not 
      if (!this.utils.isUserLoggedIn()) {
        //if not skip the mandatory checks and navigate the user. 
        if(environment.demoGamesExemptedCountries.indexOf(this.countryDataService.ipCountry) >= 0) {
          this.router.navigate([this.langCode]);
        }else {
          this.checksCompletedLaunchGame(gameId, gameLaunchUrlPath);
        }
      } 
      // if user logged and if profile is not available getting the profile then executing the mandatory checks
      else {
        this.checksCompletedLaunchGame(gameId, gameLaunchUrlPath);
      }
    }
    this.emitterService.broadcastOpenedGames(gameId, gameLaunchUrlPath)
  }

  // After all checks execution completed launching game from here.
  checksCompletedLaunchGame(gameId, gameLaunchUrlPath) {
    // console.log("all checks done game launch triggered")
    this.router.navigate([this.langCode + '/gameplay/' + gameLaunchUrlPath]);
    // setTimeout is used to handle the gamelaunch
    setTimeout(() => {
      if(this.isSameGameLaunched) {
        this.emitterService.broadCastGameWindowMinimized(false);
      } else {
        this.emitterService.broadCastIsGameWindowInitialized(true);
      }
    });
    this.isGameLaunchChecksCanStart = true;
  }

  isRealUserAccount() {
    return this.isRealUser;
  }

  getUserFormatedBalence(amount, isNotDecimal=false){
    amount = (amount ? amount : 0)
    if(!isNotDecimal){
      amount = amount.toFixed(2);
    }
    if(this.userCurrencyInfo){
      let currencySymbol = this.userCurrencyInfo?.symbol
      if(amount && currencySymbol && this.userCurrencyInfo?.position == 'before'){
       return currencySymbol+' '+amount;
      }
      return amount+" "+currencySymbol;
    }
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
